import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/ChatGPT Image Aug 24, 2026, 01_54_39 PM.png';

const GlobalMarketingIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Global Marketing"
      subtitle="Marketplace for Film Industry"
      desc="Promote, sell and collaborate with creators, buyers and professionals worldwide. Expand your reach, discover new talent, and launch global campaigns with ease."
      image={image}
      themeColor="#8a2be2"
      bgGradient="linear-gradient(135deg, rgba(138,43,226,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "Film Projects Marketplace",
    "desc": "Buy, sell, and fund innovative film projects securely online."
  },
  {
    "title": "Talent & Crew Listing",
    "desc": "Hire top-tier actors, directors, and crew members for your next shoot."
  },
  {
    "title": "Services & Vendors",
    "desc": "Discover trusted vendors for equipment, catering, and post-production."
  },
  {
    "title": "Global Collaboration",
    "desc": "Work across borders with integrated file sharing and localized chat."
  }
]}
    />
  );
};

export default GlobalMarketingIndustry;
